import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconAliases: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.5 9V4.5H4.875V3.75C4.875 2.50736 5.88236 1.5 7.125 1.5C8.36764 1.5 9.375 2.50736 9.375 3.75V4.5H12.75V9H14.25C15.4926 9 16.5 10.0074 16.5 11.25C16.5 12.4926 15.4926 13.5 14.25 13.5H12.75V16.5H1.5V13.5H3C4.24264 13.5 5.25 12.4926 5.25 11.25C5.25 10.0074 4.24264 9 3 9H1.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
